<ng-container *ngIf="viewModel$ | async as viewModel">
  <iframe
    width="100%"
    height="100%"
    [ngClass]="{ invisible: mapLoading }"
    allowfullscreen
    allow="accelerometer; gyroscope"
    referrerpolicy="no-referrer-when-downgrade"
    [src]="viewModel.url | trustUrl"
    (load)="mapLoading = false"
    data-cy="iframe-map"
  >
  </iframe>
  <p-skeleton
    *ngIf="mapLoading"
    width="100%"
    height="100%"
    styleClass="p-skeleton-override"
  ></p-skeleton>
  <div class="travel-time-overlay">
    <ng-container *ngIf="viewModel.canCalculateDistances">
      <app-travel-time
        [route]="{
          start: 'dock',
          end: 'dock',
        }"
        label="Dock to dock"
      ></app-travel-time>
      <hr />
      <app-travel-time
        [route]="{
          start: 'start',
          end: 'end',
        }"
        label="Start to end"
      ></app-travel-time>
      <button
        type="button"
        class="freya-link-button p-mt-2"
        *ngIf="viewModel.showOpenRouteLink"
        (click)="store.dispatch(actions.openDirectionsButtonClicked())"
      >
        <i class="pi pi-external-link"></i>Open Route in Google Maps
      </button>
    </ng-container>
    <span *ngIf="!viewModel.canCalculateDistances"
      >Save changes to calculate distance.</span
    >
  </div>
</ng-container>
